import { render, staticRenderFns } from "./OmaProcedure.vue?vue&type=template&id=d5c34e4a"
import script from "./OmaProcedure.vue?vue&type=script&lang=js"
export * from "./OmaProcedure.vue?vue&type=script&lang=js"
import style0 from "./OmaProcedure.vue?vue&type=style&index=0&id=d5c34e4a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports